import { render, staticRenderFns } from "./FormInputLabel.vue?vue&type=template&id=a1d45a36&scoped=true"
import script from "./FormInputLabel.vue?vue&type=script&lang=js"
export * from "./FormInputLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1d45a36",
  null
  
)

export default component.exports